import {Button, ConfigProvider, notification, Space} from 'antd';
import React, {Component} from 'react';
import './index.css';
import enUSIntl from "antd/lib/locale/en_US";
import ProTable, {ProColumns} from "@ant-design/pro-table";
import {postRequest} from "../../../api/postRequest";
import {FileTextOutlined} from "@ant-design/icons";
import {humanFileSize} from "../../../common/utils";
import withRouter from "../../../components/withRouter";


export interface IPaymentCycleUnmatchedFilesProps {
    //Here we pass the Props Interface
    params: any
    pageSize?: number
    polling?: false | number
}

export interface IPaymentCycleUnmatchedFilesState {


}


type PaymentCycleUnmatchedFile = {
    cycle_id: string;
    filename: string;
    size: number;
};


//class ComponentName Component<PropsInterface, StateInterface>
class PaymentCycleUnmatchedFiles extends Component<IPaymentCycleUnmatchedFilesProps, IPaymentCycleUnmatchedFilesState> {

    constructor(props: IPaymentCycleUnmatchedFilesProps) {
        super(props);


    }

    //Add style here
    style = {};


    // Before the component mounts, we initialise our state
    componentWillMount() {

    }

    // After the component did mount, we set the state.
    componentDidMount() {


    }

    columns: ProColumns<PaymentCycleUnmatchedFile>[] = [
        {
            title: 'Filename', dataIndex: 'filename', valueType: 'text',
        },
        {
            title: 'Product', dataIndex: 'product', valueType: 'text'
        },
        {
            title: 'Size',
            dataIndex: 'size',
            render: (num) => humanFileSize(num as number),
            sorter: (a, b) => a.size - b.size, defaultSortOrder: "descend"
        },
    ];


    render() {


        return (
            <>

                {/*<Typography.Title level={4}>Payment Cycle {this.props.cycle_id} Logs</Typography.Title>*/}

                <ConfigProvider locale={enUSIntl}>

                    {/*<Card bodyStyle={{padding: 0}}>*/}

                    <ProTable<PaymentCycleUnmatchedFile>
                        columns={this.columns}
                        // actionRef={this.state.actionRef as any}
                        // cardBordered
                        bordered
                        // size={"small"}
                        // style={{fontSize:6}}
                        // showHeader={false}
                        // headerTitle={"Logs"}
                        polling={this.props.polling || 0}
                        request={async (params = {}, sort, filter) => {
                            const res = await postRequest('/api/paymentCycles/getUnmatchedFiles/' + this.props.params.id)
                            const data = res.data || []
                            // console.log(res.data)
                            return {data, success: true, total: data.length}
                        }}
                        rowKey="filename"
                        search={false}
                        locale={{emptyText: <Space direction={'vertical'}> <FileTextOutlined/>No exported unmatched files</Space>}}
                        pagination={{pageSize: this.props.pageSize || 10, hideOnSinglePage: true}}
                        dateFormatter="string"
                        toolbar={{style: {marginBottom: 20, textAlign: "end"}}}
                        // toolBarRender={false}
                        // toolBarRender={() => []}
                    />
                    {/*</Card>*/}


                </ConfigProvider>

            </>
        );
    }
}

export default withRouter(PaymentCycleUnmatchedFiles);